import { func } from 'prop-types';
import { compose, withStateHandlers, withContext } from 'recompose';

/**
 * This adds a forceBreakdownItem and setForceBreakdownItem prop to a component.
 * These props will be passed down the tree with as context.
 * */
export default compose(
  withStateHandlers(
    ({ forceBreakdownItem = null }: any) => ({
      forceBreakdownItem,
    }),
    {
      setForceBreakdownItem: () => (value: any): any => ({
        forceBreakdownItem: value,
      }),
    }
  ),
  withContext(
    {
      setForceBreakdownItem: func,
    },
    ({ setForceBreakdownItem }: any) => ({
      setForceBreakdownItem,
    })
  )
);
